export default {
  Valid: 0,
  DataExist: 1,
  NotValid: 2
};
